export enum CalendarModeEnum {
  Inclusive = 'inclusive',
  Exclusive = 'exclusive',
}
